import { Project } from '../models/project';
import { ProjectXCompoundXModel } from '../models/project-x-compound-x-model';
import { Constants } from './constants';

export function isPwcV2Project(project: Project): boolean {
  return !!project.projectXCompoundXModel?.find(
    (x: ProjectXCompoundXModel) => x.ModelName === Constants.MODELS.PWC2 && x.ModelVersion === 'V2'
  );
}
